import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllProductSettings } from "../../../redux/slices/productSettingsSlice";
import ShippingFields from "../../common/ShippingFields";

const ConnectedShippingFields = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const { requirePhone = false } = useSelector(selectAllProductSettings);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );
    const {
        options: {
            shipToFirstName = "First Name",
            shipToLastName = "Last Name",
            shipToAddressLine1 = "Address",
            shipToAddressLine2 = "Apartment, Suite, Etc.",
            shipToCityLabel = "City",
            shipToStateLabel = "State",
            shipToZipCodeLabel = "Zip Code",
            shipToCountryLabel = "Country",
        },
    } = control;

    const shippingFieldsProps = {
        requirePhone,
        shipToFirstName,
        shipToLastName,
        shipToAddressLine1,
        shipToAddressLine2,
        shipToCityLabel,
        shipToStateLabel,
        shipToCountryLabel,
        shipToZipCodeLabel,
    };
    return <ShippingFields {...shippingFieldsProps} />;
};

ConnectedShippingFields.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedShippingFields;
